import React, { useEffect, useState } from 'react';
import bot from '../images/happy.png';
import you from '../images/boy.png';
import LoadingDots from './LoadingDots';
import Residential from './Residential';
import Commercial from './Commercial';

const Amenitics = ({ siteId }) => {
  const [time] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [showFrame, setShowFrame] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const handleShowFrame = () => {
    setShowFrame(true);
  }

  const amenitiesDesc = (id) => {
    switch (id) {
      case 1:
        return (
          <div className="frame1">
                <strong>Akaay Infra:</strong> <div>Incredible amenities and amazing features you would never want to miss!</div><br />
                <strong>Amenities:</strong>
  
                <ul>
                  <li>Clubhouse, Swimming pool</li>
                  <li>A/c Gym, A/c Multi-purpose hall</li>
                  <li>Indoor badminton court, Basketball court</li>
                  <li>Table tennis, Game Zone, Jacuzzi seating</li>
                  <li>Cricket net practise with bowling machine</li>
                  <li>Open yoga & meditation, Mini home theatre</li>
                  <li>Children play area, Jogging track, Skating rink</li>
                  <li>Cycle track, Party lawn, Amphitheatre, Gazebo</li>
                </ul>
              </div>
        );
      case 2:
        return (
          <div className="frame1">
          <strong>Akaay Infra:</strong> <div>Incredible amenities and amazing features you would never want to miss!</div><br />
          <strong>Amenities:</strong>

          <ul>
            <li>Clubhouse, Swimming pool</li>
            <li>A/c Gym, A/c Multi-purpose hall</li>
            <li>Indoor badminton court, Basketball court</li>
            <li>Table tennis, Game Zone, Jacuzzi seating</li>
            <li>Cricket net practise with bowling machine</li>
            <li>Open yoga & meditation, Mini home theatre</li>
            <li>Children play area, Jogging track, Skating rink</li>
            <li>Cycle track, Party lawn, Amphitheatre, Gazebo</li>
          </ul>
        </div>
        );
      case 3:
        return (
          <div className="frame1">
          <strong>Akaay Infra:</strong> <div>Incredible amenities and amazing features you would never want to miss!</div><br />
          <strong>Amenities:</strong>

          <ul>
            <li>Clubhouse, Swimming pool</li>
            <li>A/c Gym, A/c Multi-purpose hall</li>
            <li>Indoor badminton court, Basketball court</li>
            <li>Table tennis, Game Zone, Jacuzzi seating</li>
            <li>Cricket net practise with bowling machine</li>
            <li>Open yoga & meditation, Mini home theatre</li>
            <li>Children play area, Jogging track, Skating rink</li>
            <li>Cycle track, Party lawn, Amphitheatre, Gazebo</li>
          </ul>
        </div>
        );
      case 4:
        return (
          <div className="frame1">
                <strong>Akaay Infra:</strong> <div>Incredible amenities and amazing features you would never want to miss!</div><br />
                <strong>Amenities:</strong>
  
                <ul>
                  <li>Clubhouse, Swimming pool</li>
                  <li>A/c Gym, A/c Multi-purpose hall</li>
                  <li>Indoor badminton court, Basketball court</li>
                  <li>Table tennis, Game Zone, Jacuzzi seating</li>
                  <li>Cricket net practise with bowling machine</li>
                  <li>Open yoga & meditation, Mini home theatre</li>
                  <li>Children play area, Jogging track, Skating rink</li>
                  <li>Cycle track, Party lawn, Amphitheatre, Gazebo</li>
                </ul>
              </div>
        );
      default:
        return (
          <div className="frame1">
            <strong>Akaay Infra:</strong>
            <div>No amenities found for this site.</div>
          </div>
        );
    }
  };

  return (
    <div>
      <div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time.toLocaleTimeString()}
      </div>

      <div className="you-message">
        <div className="frame2">Amenities</div>
      </div>

      <div className="chatbot">
        <img src={bot} alt="bot" className="bot" />
        <div className="chatbot-time">{time.toLocaleTimeString()}</div>
      </div>

      {loading ? (
    <div className='frame1'><LoadingDots /></div>
    ) : (
      <>
     {amenitiesDesc(siteId)}
    <div>
    <div className="frame1">
      It's nice to interact with you. How do you want to take it forward?<br></br>
      <div style={{textAlign: 'center'}}>
      <button className='details-button1' style={{  width: '45%', fontSize: '13px' }}  onClick={handleShowFrame}>Return to previous menu</button>
      </div>
    </div> 

    </div>
    </>
    )}

   

{showFrame && ( (siteId === 1 || siteId === 2)? (<Residential />) : (<Commercial />))}

    </div>
  );
};

export default Amenitics;
